export default __webpack_public_path__ + "static/media/2.water-treatment-plant.36f9ae64.jpg";